export default function() {

  //https://docs.signalwire.com/reference/relay-sdk-js/v1/#api-reference-relay-properties
  //<script type="text/javascript" src="https://unpkg.com/@signalwire/js@^1"></script>
  
  function SigWire() {
    let sig = this;
    sig.state = "disconnected";
    sig.uistate = "idle";

    sig.init = function(opt) {
      console.log(JSON.stringify(opt));
      sig.project = opt.project;
      sig.token = opt.token;
      sig.number = opt.number.replace(/[\(\)\s\-\.]/g, "");
      sig.cb = opt.cb;
      sig.get_audio_el = opt.get_audio_el;
      if (!sig.number || !sig.project || !sig.token) {
        delete sig.token;
        console.log("SigWire: init missing arguments");
        return false;
      }
      console.log("SigWire: init",sig.project,sig.token,sig.number);
      return true;
    }

    sig.callback = function() {
      if (!sig.cb) { return; }
      sig.cb(sig.state, sig.uistate, sig.muted);
    }

    sig.onready = function() {
      sig.state = "connected";

      if (!sig.number) {
        console.warn("onready: number missing");
        sig.disconnect();
        return;
      }
      const params = {
        destinationNumber: sig.number, 
        audio: true, 
        video: false, 
      };
      sig.call = sig.client.newCall(params);
      sig.callback();
    }

    sig.onclose = function() {
      console.log("SigWire onclose");
      sig.state = "disconnected";
      delete sig.call;
      delete sig.client;
      delete sig.token;
      delete sig.number;
      sig.callback();
    }

    sig.onerror = function(error) {
      console.log("SigWire onerror");
      sig.state = "error";
      console.warn("sigwire:"+error);
      delete sig.call;
      delete sig.client;
      sig.callback();
    }

    sig.onnotify = function(n) {
      switch (n.type) {
      case 'callUpdate':
        let call = sig.call = n.call;
        // call same as sig.call ??
        console.log("callUpdate", call.state);
        /* Typical dial-out state sequence:
              new => requesting => trying => early => talk
           HangUp/Disconnect
              purge => hangup => destroy
         */
        switch (call.state) {
        case 'new':
          break;
        case 'requesting':
          break;
        case 'trying':
          // Trying outbound call and should ring after a bit 
          sig.uistate = "outring";
          break;
        case 'early':
          break;
        case 'talk':
          sig.uistate = "talk";
          break;
        case 'recovering':
          // Recovering from a previous call 
          sig.uistate = "recover";
          if (confirm('Recover the previous call?')) {
            call.answer();
          } else {
            call.hangup();
          }
          break;
        case 'ringing':
          sig.uistate = "inring";
          // Someone is calling you - not supporting this usecase
          //if (confirm('Pick up the call?')) {
          //  currentCall.answer();
          //} else {
          //  currentCall.hangup();
          //}
          break;
        case 'active':
          // Call is  active
          sig.uistate = "talk";
          break;
        case 'purge':
          break;
        case 'hangup':
          // Call is over
          sig.call = null;
          sig.uistate = "hangup";
          break;
        case 'destroy':
          // Call has been destroyed
          sig.call = null;
          sig.disconnect();
          break;
        case 'purge': 
          break;
        }
        break;

      case 'userMediaError':
        // Permission denied or invalid audio/video params on `getUserMedia`
        console.warn("SigWire: userMediaError");
        break;
      default:
        console.warn("SigWire: unknown",n.type);
        break;
      }
      sig.callback();
    }

    sig.disconnect = function() {
      if (!sig.client) { return; }
      if (sig.state == "disconnecting" ||
          sig.state == "disconnected") {
        return;
      }
      sig.state = "disconnecting";
      sig.client.disconnect();
    }

    sig.connect = function() {
      if (!sig.number || !sig.project || !sig.token) {
        console.warn("connect: missing arguments");
        return;
      }
      sig.uistate = "setup";
      let client = sig.client = new Relay({
        project: sig.project,
        token: sig.token,
      });

      client.remoteElement = sig.get_audio_el;
      //client.localElement = 'localAudio';
      client.iceServers = [{ urls: ['stun:stun.l.google.com:19302'] }];
      client.enableMicrophone();
      client.disableWebcam();

      client.on('signalwire.ready', sig.onready);
      client.on('signalwire.socket.close', sig.onclose);
      client.on('signalwire.error', sig.onerror);
      client.on('signalwire.notification', sig.onnotify);

      sig.state = "connecting";
      sig.callback();
      client.connect();
    }

    sig.hangup = function() {
      if (sig.call && sig.call.hangup) {
        sig.call.hangup();
      } else {
        sig.disconnect();
      }
    }

    sig.mute_toggle = function() {
      if (!sig.call || !sig.call.muteAudio) {
        return sig.muted;
      }
      if (sig.muted) {
        sig.muted = false;
        sig.call.unmuteAudio();
      } else {
        sig.muted = true;
        sig.call.muteAudio();
      }
      console.log("muted:"+sig.muted);
      return sig.muted;
    }

    sig.send_dtmf = function(val) {
      console.log("send dtmf:"+val);
      if (!sig.call || !sig.call.dtmf) {
        return;
      }
      sig.call.dtmf(String(val));      
    }
    
  }
  return SigWire;
}
